import variousDogBreedsJpg from './variousDogBreeds.jpg';
import variousDogBreedsWebP from './variousDogBreeds.webp';

export const variousDogBreedsSources = [
  variousDogBreedsWebP,
  variousDogBreedsJpg,
];
